import React from 'react';
import PropTypes from 'prop-types';
import playerConstants from '../constants/playerConstants';
import PlayerAvatar from './PlayerAvatar';

function Players({ friendsData, handlePlayerInteraction, friendsInGame }) {
  const { maxNumberOfAvatarsShown } = playerConstants;
  const lengthOfFriendIds = friendsInGame.length;
  const overflowNumberOfAvatars =
    lengthOfFriendIds > maxNumberOfAvatarsShown
      ? `+${friendsInGame.length - maxNumberOfAvatarsShown + 1}`
      : 0;
  const friendsObj = {};
  friendsData.forEach(friend => {
    friendsObj[friend.id] = friend;
  });
  return (
    <ul
      data-testid='game-players-players'
      className='cursor-pointer game-card-avatar-slots'
      onClick={handlePlayerInteraction}
      aria-hidden='true'>
      {friendsInGame.length &&
        friendsInGame.map((friendId, idx) => {
          if (idx + 1 < maxNumberOfAvatarsShown && friendsObj[friendId]) {
            const keyValue = friendId + idx;
            const friend = friendsObj[friendId];
            const { id, nameForDisplay } = friend;
            return (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                key={keyValue}
                className='avatar avatar-headshot avatar-headshot-xs'
                title={nameForDisplay}>
                <PlayerAvatar playerId={id} altName={nameForDisplay} />
              </li>
            );
          }
          if (
            idx + 1 === maxNumberOfAvatarsShown &&
            friendsObj[friendId] &&
            friendsInGame.length === maxNumberOfAvatarsShown
          ) {
            const keyValue = friendId + idx;
            const friend = friendsObj[friendId];
            const { id, nameForDisplay } = friend;
            return (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                key={keyValue}
                className='avatar avatar-headshot avatar-headshot-xs'
                title={nameForDisplay}>
                <PlayerAvatar playerId={id} altName={nameForDisplay} />
              </li>
            );
          }
          if (
            idx + 1 === maxNumberOfAvatarsShown &&
            friendsInGame.length > maxNumberOfAvatarsShown
          ) {
            return (
              <li className='avatar avatar-headshot avatar-headshot-xs offset-card'>
                <span className='xsmall avatar-offset-label'>{overflowNumberOfAvatars}</span>
              </li>
            );
          }
          return null;
        })}
    </ul>
  );
}

Players.propTypes = {
  friendsData: PropTypes.arrayOf(
    PropTypes.shape({
      presense: PropTypes.shape({ userPresenceType: PropTypes.number }),
      id: PropTypes.number,
      nameForDisplay: PropTypes.string
    })
  ).isRequired,
  handlePlayerInteraction: PropTypes.func.isRequired,
  friendsInGame: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default Players;
